import { useClaimOrganizationMutation, useLazyGetNetworkQuery } from 'services/organizationsV2';
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from 'actions/userActions';
import { useCallback } from 'react';
import { useUpdateUserMutation } from 'services/user';
import { setActiveNetwork, setNetworks } from 'actions/networksActions';

export const useClaim = () => {
  const [claim, { isLoading: isClaiming }] = useClaimOrganizationMutation();
  const [getNetwork, { isLoading: isGettingNetwork }] = useLazyGetNetworkQuery();
  const history = useHistory();
  const dispatch = useDispatch();
  const [updateUser, { isLoading: isUpdatingUser }] = useUpdateUserMutation();

  const claimOrganization = useCallback(
    async ({ activeNetwork, company, userData, isOnboarding }) => {
      if (isOnboarding) {
        await updateUser({
          id: userData.id,
          onboardingCompleted: true,
        });
      }

      const { error: claimError, data: claimData } = await claim({
        collectionId: activeNetwork.id,
        organizationId: company?.id,
      });

      if (claimError) {
        toast('Failed to claim profile', {
          icon: 'error',
          id: 'claim-organization-error',
        });

        return;
      }

      const { data: networkData } = await getNetwork(claimData?.companyCollection?.id);

      const network = {
        ...networkData,
        organization: company,
      };

      const user = {
        ...userData,
        managingCollections: [...userData.managingCollections, network],
        onboardingCompleted: true,
      };

      dispatch(setActiveNetwork(network.id));
      dispatch(setNetworks(user));
      dispatch(setUser(user));

      setTimeout(() => {
        history.push(`/networks/${network.slug}/company-profile/${company.id}-${company.slug}`);
      }, 0);
    },
    [claim, getNetwork, dispatch, updateUser, history],
  );

  return { claimOrganization, isClaiming: isClaiming || isGettingNetwork || isUpdatingUser };
};
